import { render, staticRenderFns } from "./PromotionContent.vue?vue&type=template&id=bfa9ee88&scoped=true"
import script from "./PromotionContent.vue?vue&type=script&lang=js"
export * from "./PromotionContent.vue?vue&type=script&lang=js"
import style0 from "./PromotionContent.vue?vue&type=style&index=0&id=bfa9ee88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa9ee88",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Theme3DesktopPromotionCard: require('/app/components/Theme3/Desktop/PromotionCard.vue').default})
